import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/utils/api";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export default function PublicPostView() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/feed/${id}`).then((r) => setPost(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F7F3EF] flex items-center justify-center">
        <div className="text-[#5C3A2E]/50">Loading...</div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="min-h-screen bg-[#F7F3EF] flex items-center justify-center">
        <div className="text-center">
          <p className="text-[#2B2B2B]/50 mb-2">Post not found</p>
          <Link to="/" className="text-[#5C3A2E] text-sm hover:underline">Go to Kalemash</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F7F3EF] flex items-center justify-center p-4">
      <div className="w-full max-w-lg">
        <div className="bg-white rounded-2xl shadow-[0_8px_30px_rgb(92,58,46,0.12)] border border-[#EADBC8]/30 overflow-hidden">
          {post.image_path && (
            <div className="w-full aspect-[4/3] bg-[#F7F3EF]">
              <img src={`${API_BASE}/api/files/${post.image_path}`} alt="" className="w-full h-full object-cover" />
            </div>
          )}
          <div className="p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-[#EADBC8] flex items-center justify-center">
                <span className="text-sm font-semibold text-[#5C3A2E]">{post.author_name?.[0]?.toUpperCase() || "?"}</span>
              </div>
              <div>
                <span className="text-sm font-medium text-[#2B2B2B]">{post.author_name}</span>
                <p className="text-xs text-[#2B2B2B]/40">Kalemash Studio</p>
              </div>
            </div>
            {post.caption && <p className="text-[#2B2B2B] text-sm whitespace-pre-wrap">{post.caption}</p>}
          </div>
          <div className="border-t border-[#EADBC8]/30 px-6 py-3 bg-[#F7F3EF]">
            <Link to="/login" className="text-xs text-[#C6A969] hover:underline">Join Kalemash Studio</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
